<template>
    <a-modal
        centered
        :visible="visible"
        title="账户余额退款"
        @ok="on_submit"
        @cancel="cancel"
        :confirmLoading="submitting"
        :width="480"
        :after-close="after_close"
    >
        <a-form-model :model="form" ref="refund-create" :rules="rules">
            <a-form-model-item label="客户编号" prop="member_id">
                <a-input v-model="form.member_id"></a-input>
            </a-form-model-item>

            <a-form-model-item label="退款金额" prop="scope">
                <a-radio-group v-model="form.scope" button-style="solid">
                    <a-radio-button value>自定义金额</a-radio-button>
                    <a-radio-button value="balance">全部余额</a-radio-button>
                </a-radio-group>
            </a-form-model-item>

            <a-form-model-item label="填写退款金额" prop="amount" v-if="form.scope == ''">
                <a-input v-model="form.amount"></a-input>
            </a-form-model-item>

            <a-form-model-item label="客户付款方式" prop="remark">
                <a-textarea v-model="form.remark"></a-textarea>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        member_id: null,
        remark: null,
        amount: null,
        scope: "",
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            callback: null,
            record: null,
        },
        data() {
            return {
                submitting: false,
                rules: {
                    member_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    amount: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    remark: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                },
                form: null,
            };
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        watch: {
            visible(e) {
                if (e && this.record) {
                    // Object.keys(this.form).map((v) => {
                    //     if (Object.prototype.hasOwnProperty.call(this.record, v)) {
                    //     }
                    // });
                }
            },
        },
        methods: {
            cancel() {
                this.$emit("close");
            },
            on_submit() {
                this.$refs["refund-create"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.$http
                            .post("/apply/refund", this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.cancel();
                                    this.$message.success(res.message);
                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({ title: "失败", centered: true, content: res.message });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },

            after_close() {
                this.$refs["refund-create"].resetFields();

                this.form = JSON.parse(JSON.stringify(init_form));
            },
        },
    };
</script>
